export interface AssemblyModel {
  name: string;
  objectIdentifier: string;
  description?: string;
  assemblyType: AssemblyType;
  /**
   * ObjectIdentifier of the group a per-document assembly belongs to; undefined
   * for flow-wide. Scopes referenceable prompts to the assigned group.
   */
  assignedGroupObjectIdentifier?: string;
}

export enum AssemblyType {
  DocxFlowWide = "DocxFlowWide",
  DocxPerDocument = "DocxPerDocument",
}
